// -----------新-------------
const aaa = [
	{
		path: "shenpiList",
		component: () => import("@/views/caigouNew/shenpi/list.vue"),
		meta:{title:'审批',keepAlive:true},
	},
	{
		path: "weishenpiList",
		component: () => import("@/views/caigouNew/shenpi/weishenpi.vue"),
		meta:{title:'审批'},
	},
	{
		path: "yishenpiList",
		component: () => import("@/views/caigouNew/shenpi/yishenpiList.vue"),
		meta:{title:'审批'},
	},
	{
		path: "shenpibohui",
		component: () => import("@/views/caigouNew/shenpi/shenpibohui.vue"),
		meta:{title:'审批'},
	},
	{
		path: "caigouList",
		component: () => import("@/views/caigouNew/caigou/caigouList.vue"),
		meta:{title:'采购列表'},
	},
	{
		path: "addcaigou",
		component: () => import("@/views/caigouNew/caigou/addCaigou.vue"),
		meta:{title:'采购列表'},
	},
	{
		path: "cgzDetail",
		component: () => import("@/views/caigouNew/caigou/cgzDetail.vue"),
		meta:{title:'采购列表'},
	},
	{
		path: "cgwcDetail",
		component: () => import("@/views/caigouNew/caigou/cgwcDetail.vue"),
		meta:{title:'采购列表'},
	},
	
]
export default aaa;